import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import HomePage from "./pages/HomePage";
import ErrorPage from "./pages/ErrorPage";
import FreeIntroPadel from "./pages/FreeIntroPadel";
import MorningLandingPage from "./pages/MorningLandingPage";
import EventsPage from "./pages/EventsPage";
import CoachingPage from "./pages/CoachingPage";
import ScrollToTop from "./components/ScrollToTop";
import BannerComponent from "./components/BannerComponent";

function App() {
  return (
    <Router>
      <AppInner />
    </Router>
  );
}

function AppInner() {
  return (
    <>
      <BannerComponent
        title="New to padel?"
        message=" Join our FREE Intro Lesson!"
        link={{ text: "SIGN UP NOW!", url: '/free-intro' }}
        variant="info"
      />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/pricing" element={<Navigate to="/#membership" replace />} />
        <Route path="/about-us" element={<Navigate to="/" replace />} />
        <Route path="/contact" element={<Navigate to="/#visit" replace />} />
        <Route path="/free-intro" element={<FreeIntroPadel />} />
        <Route path="/mornings" element={<Navigate to="/morning" replace />} />
        <Route path="/morning" element={<MorningLandingPage />} />
        <Route path="/morning-club" element={<Navigate to="/morning" replace />} />
        <Route path="/morning-lp" element={<Navigate to="/morning" replace />} />
        <Route path="/private-events" element={<Navigate to="/events#event-options" replace />} />
        <Route path="/corporate-events" element={<Navigate to="/events#event-options" replace />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/coaching" element={<CoachingPage />} />
        <Route path="/qrcode1" element={<HomePage />} />
        <Route path="/qrcode2" element={<HomePage />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </>
  );
}

export default App;
